import { UserAction } from '@api/userActionsApiHandler';
import TaskAltOutlinedIcon from '@assets/images/icons/task-alt-outlined.svg';
import { MotionImage, MotionText } from '@shared/atoms';
import { NoDataBlueTraySection, SystemButton } from '@shared/molecules';
import { ActionCard } from '@shared/organisms/Plans/ActionCard/ActionCard';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './index.module.scss';

interface WellbeingPlanProps {
  actionItems: UserAction[] | [];
  refetchActions: () => void;
}

export const WellbeingPlan: React.FC<WellbeingPlanProps> = ({ actionItems, refetchActions }) => {
  const history = useHistory();

  return (
    <section className={styles.planSection} aria-labelledby="plan-heading">
      <div className={styles.planHeader}>
        <div className={styles.planIcon} aria-hidden="true">
          <MotionImage src={TaskAltOutlinedIcon} alt="" className={styles.icon} />
        </div>

        <MotionText
          id="plan-heading"
          className={styles.sectionTitle}
          as="h3"
          text="Your wellbeing plan"
        />
      </div>

      <MotionText
        className={styles.planDescription}
        as="text"
        text="We've created a personalised plan of suggested actions and activities. These
          recommendations aim to support and improve your wellbeing."
      />

      <div className={styles.actionSection}>
        {actionItems.length > 0 ? (
          actionItems.map((item: UserAction, index: number) => {
            const dueDate =
              item.dueDays >= 0
                ? `${Math.abs(item.dueDays)} days to go`
                : `${Math.abs(item.dueDays)} days overdue`;

            const overdue = item.dueDays < 0;

            return (
              <ActionCard
                key={index}
                actionData={item}
                className={`${styles.actionCard} ${styles.calmLilac}`}
                title={item.title || ''}
                description={item.description || ''}
                dueDate={dueDate}
                completed={item.completed !== null}
                overdue={overdue}
                theme="#beaaf3"
                actionButtonName={item?.actionButtonTitle || null}
                actionImage={item.actionImage}
                handleRefetch={refetchActions}
                isDashboardAction
              />
            );
          })
        ) : (
          <NoDataBlueTraySection text="No active actions found." />
        )}
      </div>

      {actionItems.length > 0 && (
        <div className={styles.viewPlanContainer}>
          <SystemButton
            className={styles.viewPlanButton}
            aria-label="View your complete wellbeing plan"
            size="medium"
            onClick={() => history.push('/improve-plans')}
          >
            View Your Plan
          </SystemButton>
        </div>
      )}
    </section>
  );
};
